import React from 'react'

function Container({children}) {
  return (
    <div className="max-w-container mx-auto p-2.5">
        {children}
    </div>
  )
}

export default Container